import { combineReducers } from "redux";
import { ControllerReducers } from "@src/core/controllers/store";
import { OrderFeatureReducers } from "@src/features/order/store";
import { IntegrationFeatureReducers } from "@src/features/integration/store";
import { FleetFeatureReducers } from "@src/features/fleet/store";
import { DroneFeatureReducers } from "@src/features/drone/store";
import { AuthFeatureReducers } from "@src/features/auth/store";
import { HistoryFeatureReducers } from "@src/features/history/store";
import { ProfileCoreReducers } from "@src/core/features/profile/store";
import { SettingsCoreReducers } from "@src/core/features/settings/store";
import { ZonesCoreReducers } from "@src/core/features/zones/store";
import { DroneCoreReducers } from "@src/core/features/drone/store";
import { ZonesFeatureReducers } from "@src/features/zones/store";
import { AnalyticsFeatureReducers } from "@src/features/analytics/store";

export const reducer = combineReducers({
  ...AuthFeatureReducers,
  ...ControllerReducers,
  ...OrderFeatureReducers,
  ...FleetFeatureReducers,
  ...DroneFeatureReducers,
  ...ProfileCoreReducers,
  ...SettingsCoreReducers,
  ...IntegrationFeatureReducers,
  ...HistoryFeatureReducers,
  ...ZonesCoreReducers,
  ...DroneCoreReducers,
  ...ZonesFeatureReducers,
  ...AnalyticsFeatureReducers,
});
